import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Axios from "axios";
import BEP20_ABI from "src/contract-logic/abis/BEP20_ABI.json";
import WBNB_ABI from "src/contract-logic/abis/WBNB_ABI.json";
import Web3 from "web3";

export const fetchPrice = createAsyncThunk("priceSlice/fetchPrice", async () => {
  const busd = { id: "busd", underlyingAddress: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56" };
  const mainnetWeb3Reader = new Web3("https://bsc-dataseed2.ninicoin.io/");
  const WBNB_ADDRESS = "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c";
  const wbnbContract = new mainnetWeb3Reader.eth.Contract(WBNB_ABI, WBNB_ADDRESS);
  const busdContract = new mainnetWeb3Reader.eth.Contract(BEP20_ABI, busd.underlyingAddress);

  const wbnbBusdLpAddress = "0x1B96B92314C44b159149f7E0303511fB2Fc4774f";
  const wbnbBalanceBusdlp = await wbnbContract.methods.balanceOf(wbnbBusdLpAddress).call();
  const busdBalanceBusdlp = await busdContract.methods.balanceOf(wbnbBusdLpAddress).call();
  const bnbPrice = parseInt(busdBalanceBusdlp) / parseInt(wbnbBalanceBusdlp);

  const res = await Axios.get("https://scoringapi.trava.finance/supply/app/v0.1/trava-price").then((res) => res.data);
  const travaPrice = res.price_usd;
  let usdtPrice;
  try {
    usdtPrice = await Axios.get("https://api.coingecko.com/api/v3/simple/price?ids=tether&vs_currencies=usd").then(
      (res) => res.data
    );
  } catch (error) {
    console.error(error);
  }
  return { bnbPrice, travaPrice, usdtPrice: usdtPrice?.tether?.usd };
});

const priceSlice = createSlice({
  name: "priceSlice",
  initialState: {},
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(fetchPrice.fulfilled, (state, action) => {
        Object.assign(state, action.payload);
      })
      .addCase(fetchPrice.rejected, (_, action) => {
        console.error(action);
      }),
});

export default priceSlice.reducer;
